import React from 'react';
import { MARY_KAY_OAUTH_CODE_VERIFIER } from '@plug/config/consts';
import pkceChallenge from 'oauth-pkce';
import {
  MARY_KAY_ID_OAUTH2,
  MARY_KAY_OAUTH_AUTHORIZE_URL,
  MARY_KAY_OAUTH_REDIRECT_URI,
} from '@plug/config/env';
import { useCallback } from 'react';
import useLocalStorage from '@plug/hooks/use-local-storage';
import { Button } from '@lomadee/design-system';

export const SSOButton = () => {
  const { set } = useLocalStorage();

  const handleMaryKayOAuth = useCallback(async () => {
    pkceChallenge(128, (err, { challenge, verifier }) => {
      try {
        set(MARY_KAY_OAUTH_CODE_VERIFIER, verifier);
        const clientId = MARY_KAY_ID_OAUTH2;
        const responseType = 'code';
        const scope = 'openid';
        window.location.href = `${MARY_KAY_OAUTH_AUTHORIZE_URL}/services/oauth2/authorize?client_id=${clientId}&redirect_uri=${MARY_KAY_OAUTH_REDIRECT_URI}&response_type=${responseType}&scope=${scope}&code_challenge=${challenge}`;
      } catch (error) {
        console.log({ error });
      }
    });
  }, [set]);

  return <Button onClick={handleMaryKayOAuth}>Tentar novamente</Button>;
};
